import React, { useState } from 'react';
import './MobileMapControls.css';

interface MobileMapControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onRecenter: () => void;
  onToggleFilters: () => void;
  activeFiltersCount: number;
  mapStyle: 'streets' | 'satellite' | 'dark';
  onStyleChange: (style: 'streets' | 'satellite' | 'dark') => void;
}

const MobileMapControls: React.FC<MobileMapControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onRecenter,
  onToggleFilters,
  activeFiltersCount,
  mapStyle,
  onStyleChange
}) => {
  const [showStylePicker, setShowStylePicker] = useState(false);

  const mapStyles = [
    { id: 'streets', label: 'Streets', icon: '🗺️' },
    { id: 'satellite', label: 'Satellite', icon: '🛰️' },
    { id: 'dark', label: 'Dark', icon: '🌙' }
  ];

  return (
    <div className="mobile-map-controls">
      {/* Filter Button - Top Left */}
      <button 
        className="map-control-btn filter-btn"
        onClick={onToggleFilters}
        aria-label="Toggle filters"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M2 5h16M5 10h10M8 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
        {activeFiltersCount > 0 && (
          <span className="filter-badge">{activeFiltersCount}</span>
        )}
      </button>

      {/* Map Controls - Right Side */}
      <div className="map-controls-group">
        <button 
          className="map-control-btn"
          onClick={onRecenter}
          aria-label="Recenter map"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
            <path d="M10 1v3M10 16v3M1 10h3M16 10h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>

        <div className="zoom-controls">
          <button 
            className="map-control-btn zoom-in"
            onClick={onZoomIn}
            aria-label="Zoom in"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 5v10M5 10h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <button 
            className="map-control-btn zoom-out"
            onClick={onZoomOut}
            aria-label="Zoom out"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M5 10h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <button 
          className="map-control-btn"
          onClick={() => setShowStylePicker(!showStylePicker)}
          aria-label="Change map style"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="2" y="2" width="7" height="7" stroke="currentColor" strokeWidth="2" rx="1"/>
            <rect x="11" y="2" width="7" height="7" stroke="currentColor" strokeWidth="2" rx="1"/>
            <rect x="2" y="11" width="7" height="7" stroke="currentColor" strokeWidth="2" rx="1"/>
            <rect x="11" y="11" width="7" height="7" stroke="currentColor" strokeWidth="2" rx="1"/>
          </svg>
        </button>
      </div>

      {/* Map Style Picker */}
      {showStylePicker && (
        <div className="map-style-picker">
          {mapStyles.map(style => (
            <button
              key={style.id}
              className={`style-option ${mapStyle === style.id ? 'active' : ''}`}
              onClick={() => {
                onStyleChange(style.id as any);
                setShowStylePicker(false);
              }}
            >
              <span className="style-icon">{style.icon}</span>
              <span className="style-label">{style.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* Search Field - Bottom */}
      <div className="map-search-container">
        <input
          type="search"
          className="map-search-input"
          placeholder="Search location..."
          aria-label="Search location"
        />
        <button className="map-search-btn" aria-label="Search">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2"/>
            <path d="M13 13l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default MobileMapControls;